<template>
  <div class="flex flex-col ">
    <div class="card">
      <span>{{ label }}</span>
      <VanField ref="field" :value="value" @input="onInputChange" placeholder="Enter Flavor"
          :style="{
              '--fieldBorderColor': showInputError ? 'red' : '#e8e8e8',
              '--fieldColor': showInputError ? 'red' : '#333',
            }"/>
    </div>

    <div class="grid grid-cols-4 gap-2 mt-3 text-center">
      <div class="bg-white h-10 leading-10 tag-item"
          :class="item.selected ? 'active':''"
          v-for="(item,index) in tags" :key="item.id"
          @click="onTagClicked(index)"
      >
        {{ item.labelName }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FlavorSelect",
  props: {
    label: {
      type: String,
      default: ""
    },

    value: {
      type: String,
      default: ""
    },
    tags: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      showInputError:false
    }
  },
  methods: {
    validate() {
      if (!this.value) {
        this.showInputError = true
      }else {
        this.showInputError = false
      }

    },
    onInputChange(e) {
      if (e === "") {
        this.showInputError = true;
      }else {
        this.showInputError = false;
      }
      this.$emit("input", e);
    },
    onTagClicked(index) {
      this.$emit('tagChange',index)
    }
  }
};
</script>


<style scoped lang="less">
::v-deep .van-cell {
  border: 1px #e8e8e8 solid;
  border-radius: 12px;
  padding:0 12px;
  margin-top:10px;
  border: 1px solid var(--fieldBorderColor);
  .van-field__content {
    color: 1px solid var(--fieldColor);
  }
  .van-field__body {
    padding:0;

    input{
      padding: 0 !important;
    }
  }
}

.tag-item {
  border-radius: 12px;
  font-size:14px;
}
.active {
  border-color: #679AFF;
}


</style>